@if (workOrder) {
  <div class="container">
    <div class="main-column column">
      <div class="overview-card">
        <mat-card>
          <mat-card-title>
            <button class="favourite" (click)="toggleFavourite()">
              <i class="material-icons icon">{{ workOrder.isFavourite ? 'star' : 'star_border' }}</i>
            </button>
            {{ workOrder.workOrderNumber }}
            @if (shouldShowWorkOrderProjectName()) {
              ({{ workOrderProjectName }})
            }
          </mat-card-title>
          <div class="title">
            <mat-card-subtitle>{{ workOrder.title }}</mat-card-subtitle>
          </div>
          <div class="progress">
            <app-progress
              [value]="workOrder.progress"
              [weeksProgress]="workOrder.showWeeklyProgress ? workOrder.weeksProgress : 0"
              [displayLabel]="true"
            ></app-progress>
          </div>
          @if (workOrder.showWeeklyProgress) {
            <div class="estimated-hours">
              <div class="estimated-hours_header">
                <div class="estimated-hours_header_row">
                  <div class="estimated-hours_header_row_cell description">
                    {{ 'workOrderDetails.hoursTable.header.description' | translate }}
                  </div>
                  <div class="estimated-hours_header_row_cell hours">
                    {{ 'workOrderDetails.hoursTable.header.hours' | translate }}
                  </div>
                </div>
              </div>
              <div class="estimated-hours_table">
                <div class="estimated-hours_table_row">
                  <div class="estimated-hours_table_row_cell description">
                    {{ 'workOrderDetails.hoursTable.row.estimate_hours' | translate }}
                  </div>
                  <div class="estimated-hours_table_row_cell hours">{{ workOrder.estimatedHours }}</div>
                </div>
                <div class="estimated-hours_table_row">
                  <div class="estimated-hours_table_row_cell description">
                    {{ 'workOrderDetails.hoursTable.row.hours_remaining' | translate }}
                  </div>
                  <div class="estimated-hours_table_row_cell hours">{{ workOrder.hoursRemaining }}</div>
                </div>
                <div class="estimated-hours_table_row">
                  <div class="estimated-hours_table_row_cell description">
                    {{ 'workOrderDetails.hoursTable.row.hours_earned_this_week' | translate }}
                  </div>
                  <div class="estimated-hours_table_row_cell hours">{{ workOrder.weeklyProgressHours }}</div>
                </div>
              </div>
            </div>
          }
          <div class="properties">
            <div class="property inline">
              <div class="label">{{ 'workOrderDetails.start' | translate }}</div>
              <div class="value">
                {{ workOrder.startDate | dwoDate }}
              </div>
            </div>
            <div class="property inline">
              <div class="label">{{ 'workOrderDetails.finish' | translate }}</div>
              <div class="value">{{ workOrder.endDate | dwoDate }}</div>
            </div>
            <div class="property inline">
              <div class="label">
                {{ 'workOrderDetails.estimatedHours' | translate }}
              </div>
              <div class="value">{{ workOrder.estimatedHours }}</div>
            </div>
          </div>
          <div class="properties">
            <div class="property">
              <div class="label">{{ 'workOrderDetails.wbs' | translate }}</div>
              <div class="value">
                <div>{{ workOrder.wbs || '-' }}</div>
              </div>
            </div>
            <div class="property">
              <div class="label">{{ 'workOrderDetails.statusName' | translate }}</div>
              <div class="value">
                <div>{{ workOrder.statusName || '-' }}</div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      @if (workOrder.description?.length > 0) {
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'workOrderDetails.description' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="work-order-description" [innerHTML]="workOrder.description | safeHtml"></div>
        </mat-expansion-panel>
      }
    </div>
    <div class="side-column column">
      <app-mips-comments></app-mips-comments>
      @if (workOrder.precedingWorkOrderId || workOrder.succeedingWorkOrderId) {
        <div class="linked-work-orders">
          <h2>{{ 'workOrderDetails.relatedWorkOrders' | translate }}</h2>
          <div class="linked-work-orders_row">
            @if (workOrder.precedingWorkOrderId) {
              <div class="linked-work-orders_column">
                <h3>{{ 'workOrderDetails.precedingWorkOrder' | translate }}</h3>
                <p>
                  @if (workOrder.precedingWorkOrderExists) {
                    <span class="link" role="link" (click)="navigateToWorkOrder(workOrder.precedingWorkOrderId)">{{
                      workOrder.precedingWorkOrderNumber
                    }}</span>
                    @if (workOrder.precedingWorkOrderProgress !== undefined) {
                      <span class="linked-work-orders_progress">({{ workOrder.precedingWorkOrderProgress }}%)</span>
                    }
                  } @else {
                    {{ workOrder.precedingWorkOrderId }}
                  }
                </p>
              </div>
            }
            @if (workOrder.succeedingWorkOrderId) {
              <div class="linked-work-orders_column">
                <h3>{{ 'workOrderDetails.succeedingWorkOrder' | translate }}</h3>
                <p>
                  @if (workOrder.succeedingWorkOrderExists) {
                    <span class="link" role="link" (click)="navigateToWorkOrder(workOrder.succeedingWorkOrderId)">{{
                      workOrder.succeedingWorkOrderNumber
                    }}</span>
                    @if (workOrder.succeedingWorkOrderProgress !== undefined) {
                      <span class="linked-work-orders_progress">({{ workOrder.succeedingWorkOrderProgress }}%)</span>
                    }
                  } @else {
                    {{ workOrder.succeedingWorkOrderId }}
                  }
                </p>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
